import type { PhoneNumberInput } from '../graphql/api'

declare const validPhone: unique symbol

export type PhoneNumber = string & {
    [validPhone]: true
}

export function getPhoneNumber(
    countryCode: string,
    number: string
): PhoneNumberInput | null {
    if (!countryCode || !number) {
        return null
    }
    return {
        countryCode,
        nationalNumber: number,
    }
}
